export default __webpack_public_path__ + "static/N0232-d027444d3a11a24c706ab52f9b3d6ae2.png";